<template>
  <label v-if="wrapLabel" :class="wrapCls">
    <span :class="classString" :style="h3style">
      <input :name="name" :id="id" type="checkbox" :readOnly="!editable" :disabled="disabled" :class="inputCls" @click.stop="onInnerClick($event)" :value="value" v-model="innerChecked" />
      <span :class="innerSpanCls" />
    </span>
    <slot></slot>
  </label>
  <span v-else :class="classString" :style="h3style">
    <input
      :name="name"
      :id="id"
      type="checkbox"
      :readOnly="!editable"
      :disabled="disabled"
      :tabIndex="tabIndex"
      :class="inputCls"
      @click.stop="onInnerClick($event)"
      :autoFocus="autoFocus"
      :value="value"
      v-model="innerChecked"
    />
    <span :class="innerSpanCls" />
  </span>
</template>

<script>
import cx from "classnames";

const prefixCls = "h3-checkbox";
export default {
  name: "h3-checkbox",
  props: {
    className: String,
    h3style: Object,
    name: String,
    id: String,
    // defaultChecked: {
    //   type: [Number, Boolean],
    //   default: false,
    // },
    // checked: [Number, Boolean],
    disabled: Boolean,
    // onFocus: Function,
    // onBlur: Function,
    // onChange: Function,
    // onClick: Function,
    // tabIndex: String,
    editable: {
      type: Boolean,
      default: true,
    },
    value: String,
    wrapLabel: {
      type: Boolean,
      default: true,
    },
    // group: String,
    returnValue: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
    },
    isCheckAll: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    returnValue() {
      let checked = false;
      if (this.returnValue && this.returnValue.length > 0) {
        this.returnValue.forEach((i) => {
          if (i === this.value) {
            checked = true;
          }
          if (this.value === "全选" && this.isCheckAll) {
            checked = true;
          }
        });
      }
      this.innerChecked = checked;
      // console.log('returnValue change......');
    },
    innerChecked() {
      this.handleChange();
    },
  },
  data() {
    return {
      innerChecked: false,
    };
  },
  created() {
    // console.log(this.returnValue);
    if (this.returnValue && this.returnValue.length > 0) {
      for (const i in this.returnValue) {
        if (this.returnValue[i] === this.value) {
          this.innerChecked = true;
        }
      }
    }
  },
  methods: {
    onInnerClick() {
      this.$emit("onClick", this.value, this.innerChecked);
    },
    handleChange() {
      if (this.value === "全选" && this.isCheckAll) {
        if (this.innerChecked) {
          const arr = this.options.map((item) => item);
          this.$emit("onChange", arr, this.innerChecked);
        } else {
          this.$emit("onChange", [], this.innerChecked);
        }
      } else {
        const innerValue = this.returnValue || [];
        let index = -1;
        for (const i in innerValue) {
          if (innerValue[i] === this.value) {
            index = i;
            break;
          }
        }
        if (this.innerChecked) {
          if (index === -1) {
            innerValue.push(this.value);
          }
        } else if (index > -1) {
          // 取消选中时，移除元素
          innerValue.splice(index, 1);
        }
        // console.log('checkbox changing......');
        this.$emit("onChange", innerValue, this.innerChecked);
      }
    },
  },
  computed: {
    wrapCls() {
      return cx(`${prefixCls}-wrapper`, this.className);
    },
    classString() {
      return cx(prefixCls, this.className, {
        [`${prefixCls}-checked`]: this.innerChecked,
        [`${prefixCls}-disabled`]: this.disabled,
      });
    },
    inputCls() {
      return `${prefixCls}-input`;
    },
    innerSpanCls() {
      return `${prefixCls}-inner`;
    },
    isChecked() {
      return true;
    },
  },
};
</script>
<style lang="less">
@import "../../styles/mixins";
@import "../../styles/h3-ui/h3-field.less";

@listPrefixCls: h3-list;
@checkboxWarpPrefixCls: h3-checkbox;
@checkboxInnerPrefixCls: ~"@{checkboxWarpPrefixCls}-inner";

.@{checkboxWarpPrefixCls} {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: @icon-size-sm;
  height: @icon-size-sm;
  word-break: break-all;

  &-inner {
    position: absolute;
    right: 0;
    width: @icon-size-sm;
    height: @icon-size-sm;
    border: 1 * @hd solid #ccc;
    border-radius: @radius-circle;
    transform: rotate(0deg);
    box-sizing: border-box;

    &:after {
      position: absolute;
      display: none;
      top: 1.5 * @hd;
      right: 6 * @hd;
      z-index: 999;
      width: 5 * @hd;
      height: 11 * @hd;
      border-style: solid;
      border-width: 0 1 * @hd 1 * @hd 0;
      content: "\0020";
      transform: rotate(45deg);
    }
  }

  &-input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    border: 0 none;
    appearance: none;
  }

  &.@{checkboxWarpPrefixCls}-checked {
    .@{checkboxInnerPrefixCls} {
      border-color: @brand-primary;
      background: @brand-primary;

      &:after {
        display: block;
        border-color: #fff;
      }
    }
  }

  &.@{checkboxWarpPrefixCls}-disabled {
    opacity: @opacity-disabled;

    &.@{checkboxWarpPrefixCls}-checked {
      .@{checkboxInnerPrefixCls} {
        border-color: @color-text-caption;
        background: none;

        &:after {
          border-color: @color-text-caption;
        }
      }
    }
  }
}

.@{checkboxWarpPrefixCls}-item {
  .@{listPrefixCls}-thumb {
    width: @icon-size-sm;
    height: @icon-size-sm;

    .@{checkboxWarpPrefixCls} {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      //height: @list-item-height;
      height: 100%;

      &-inner {
        left: @h-spacing-lg;
        top: 10 * @hd;
      }
    }
  }

  &.@{checkboxWarpPrefixCls}-item-disabled {
    .@{listPrefixCls}-content {
      color: @color-text-disabled;
    }
  }
}

.@{checkboxWarpPrefixCls}-agree {
  position: relative;
  display: flex;
  align-items: stretch;
  margin-left: @h-spacing-lg;
  padding-top: @v-spacing-md;
  padding-bottom: @v-spacing-md;

  .@{checkboxWarpPrefixCls} {
    position: absolute;
    left: 0;
    top: 0;
    width: 2 * @h-spacing-lg;
    height: 100%;

    &-inner {
      left: 0;
      top: 9 * @hd; // @v-spacing-xs + @v-spacing-md;
    }
  }

  .@{checkboxWarpPrefixCls}-agree-label {
    display: inline-block;
    font-size: @font-size-subhead;
    color: @color-text-base;
    line-height: @line-height-paragraph;
    margin-left: 2 * @h-spacing-lg;
    margin-top: 1px;
  }
}
</style>
